import { FixMeLater, JobEndpoint } from "@shared/types";
import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getStoreFromSliceName } from "@shared/utils/slices";

export const JOBS_SLICE_PATH = "jobs";

export interface JobsState {
  jobsData: { [key in JobEndpoint]?: Record<string, any> };
}

const InitialState: JobsState = {
  jobsData: {},
};

export const jobsSlice = createSlice({
  name: JOBS_SLICE_PATH,
  initialState: InitialState,
  reducers: {
    setJobData(
      state,
      action: PayloadAction<{ args: any; data: any; endpointName: JobEndpoint }>
    ) {
      const { args, data, endpointName } = action.payload;
      const allEndpointData = state.jobsData[endpointName] ?? {};
      const stringArgs = JSON.stringify(args);
      allEndpointData[stringArgs] = data;
      state.jobsData[endpointName] = allEndpointData;
    },
  },
});

export const jobsActions = jobsSlice.actions;

export const selectJobsState = (state: FixMeLater): JobsState =>
  getStoreFromSliceName(state, JOBS_SLICE_PATH);

export const selectJobsData = (endpointName: JobEndpoint, args: any) =>
  createSelector(selectJobsState, (jobsStore) => {
    const stringArgs = JSON.stringify(args);
    return jobsStore.jobsData[endpointName]?.[stringArgs];
  });
